import {Constant} from "./index";
import {STATE} from "../../Type";

export class BooleanBlock extends Constant {
  get type() {
    return "BooleanBlock";
  }

  get category() {
    return "Constant";
  }
  static getPrototypeBlocks() {
    return [
      new BooleanBlock({data: "true", state: STATE.PROTOTYPE}),
      new BooleanBlock({data: "false", state: STATE.PROTOTYPE}),
    ];
  }

  toJavascript() {
    return this.data;
  }
}
